"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _SideBar = _interopRequireDefault(require("./SideBar.style"));
var _dec, _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let SideBar = (_dec = (0, _reactJss.default)(_SideBar.default), _dec(_class = class SideBar extends _react.PureComponent {
  render() {
    const {
      classes,
      visibility,
      id,
      children,
      activeItem,
      onClick,
      className,
      dataTestId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Menu.default, {
      id: id,
      type: "sideBar",
      className: `${className} ${classes.sidebar}`,
      visibility: visibility,
      activeItem: activeItem,
      onClick: onClick,
      dataTestId: dataTestId
    }, _react.default.Children.map(children, (child, index) => {
      const props = child.type.displayName === 'JssContextSubscriber' ? {
        className: classes.menuItem
      } : {
        className: classes.navMenuItem
      };
      if (dataTestId && !child.props.dataTestId) {
        props.dataTestId = `${dataTestId}-item-${index}`;
      }
      return _react.default.cloneElement(child, props);
    }));
  }
}) || _class);
SideBar.defaultProps = {
  visibility: 'visible',
  onClick: () => {}
};
var _default = exports.default = SideBar;